import React, { useState, useRef, useEffect, useCallback } from 'react';
import './FullApplicationInfo.css';
import { useDispatch } from "react-redux";
import {setApplicationBackInProgress} from "../../../Store/ApplicationsReducer/applicationsActions";
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import ApplicationBackModal from '../../UI/Modals/ApplicationBackModal/ApplicationBackModal';
import 'swiper/css';
import { WebCrm_Webhook_API } from '../../../api/attachments.api';
const FullApplicationInfo = (props) => {
    const dispatch = useDispatch();
    const [swiper, setSwiper] = useState(null)
    const emptyRef= useRef(null)
    const application = props.application;
    const [currentSlide, setCurrentSlide] = useState(0)
    const [showQuestionComment, setShowQuestionComment] = useState(false);
    const [showQuestionApplicationId, setShowQuestionApplicationId] = useState(false);
    const [showQuestionSpecialist, setShowQuestionSpecialist] = useState(false);
    const [isFileImageModal, setIsFileImageModal] = useState(false);
    const nextSlide = () => {
        const nextSlide = (currentSlide + 1) % 2;
        setCurrentSlide(nextSlide);
        swiper.slideNext();
    };
    const prevSlide = () => {
        const nextSlide = (currentSlide - 1) % 2;
        setCurrentSlide(nextSlide);
        swiper.slidePrev();
    };
    const hoverShowQuestionComment = () => {
        setShowQuestionComment(true);
    }
    const hoverHideQuestionComment = () => {
        setShowQuestionComment(false);
    }
    const hoverShowQuestionApplicationId = () => {
        setShowQuestionApplicationId(true);
    }
    const hoverHideQuestionApplicationId = () => {
        setShowQuestionApplicationId(false);
    }
    const hoverShowQuestionSpecialist = () => {
        setShowQuestionSpecialist(true);
    }
    const hoverHideQuestionSpecialist = () => {
        setShowQuestionSpecialist(false);
    }
    const [currentFileImage, setCurrentFileImage] = useState("")

    const toggleModalImage = (imageSource) => {
        setCurrentFileImage(imageSource)
        setIsFileImageModal(!isFileImageModal);
    }

    const [image, setImage] = useState(undefined);

    const fetchPhoto = useCallback(async () => {
        try {
            console.log("fetchPhoto", application)
            const photo64 = await WebCrm_Webhook_API.Request.getPhotoByImplementerUUID(application?.implementer?.uuid);
            if (photo64) setImage(`data:image/jpeg;base64,${photo64}`)
        } catch (error) {
        }
    }, [application?.implementer?.uuid]);

    useEffect(() => {
        fetchPhoto();
    }, [fetchPhoto]);

    let color;
    let date;
    let status;
    let applicationId;
    let specialist;
    let specialistId;
    let workerId;
    let classLikeDislike;
    let isComment;
    let department;
    let subject;
    let solution;
    let allSolution = [];
    let fileImage;
    let problem;
    let allProblems = [];
    let workerName;
    let isProblem = false;
    if (application) {
        color = application.status.name_rus === 'Запланировано' ? "#E82024" : application.status.name_rus === 'В работе' ? "#F3BB1C" : application.status.name_rus === 'Завершено' ? "#3CC13B" : application.status.name_rus === 'Отменено' ? '#828282' : application.status.name_rus === 'Пауза' ? '#00ABCD' : null;
        date = new Date(application.started_at).toLocaleDateString() + ", " + new Date(application.started_at).toLocaleTimeString([], {hour: "2-digit", minute: "2-digit"});
        status = application.status.name_rus?.toLowerCase();
        applicationId = application.number;
        specialist = application.implementer.name_rus;
        specialistId = application.implementer.it;
        workerId = application.employee_device_id;
        classLikeDislike = application.rating_value === 1 ? "like" : application.rating_value === -1 ? "dislike" : "";

        isComment = application.rating_comment?true: false;
        department = application.department?.name_rus;
        subject = application.subject;
        solution = application.outcome;
        allSolution = (!solution && application.status.name_rus === "Отменено")?
            <p className="FullApplicationInfo__content__text">Причины не указаны</p>
            :<p className="FullApplicationInfo__content__text">{solution}</p>
        fileImage = application.attachments.length > 0 ? application.attachments.map((el, i) => {
            let fileExt = el.split('.').pop();
            let isImage = ['jpg', 'jpeg', 'png', 'bmp', 'svg', 'ico'].includes(fileExt.toLowerCase())
            return isImage ?
                    <div key={i} className="FullApplicationInfo__fileImage--canvas">
                        <img onClick={() => {toggleModalImage(el)}} className="FullApplicationInfo__fileImage" src={el} alt={subject}/>
                        {/*{inside}*/}
                    </div>
                    :
                    <div key={i} className="FullApplicationInfo__fileImage--canvas">
                        <a href={el} target='blanc' className="FullApplicationInfo__fileImage--link">{el?.split('/').pop()}</a>
                    </div>
        }) : null
        // problem = application.details.replaceAll("<br />", "").split("\n");
        problem = application.details?.split("\n")
        workerName = application?.employee?.name;
        allProblems = problem?.map((el, i) => {
            return el?.length ? <p key={i} dangerouslySetInnerHTML={{__html: `${el}`}} className={`FullApplicationInfo__content__text ${el.includes("Комментарий") ? "FullApplicationInfo__content__text--commentDate" : ""}`} /> : null
        });
        isProblem = problem?.length > 1;
    }
    const backInProgressHandler = () => {
        dispatch(setApplicationBackInProgress(application._id))
        props.clickToClose()
    }
    return (
        <>
            <div className="FullApplicationInfo">
                <div className="FullApplicationInfo__header">
                    <div onClick={props.clickToClose} className="FullApplicationInfo__close" />
                    <div className="FullApplicationInfo__statusDateBlock">
                        <p className="ResultsItemWorker__text">{date}</p>
                        <p style={{background: color}} className="FullApplicationInfo__status">{status}</p>
                    </div>

                    <div className="FullApplicationInfo__ApplicationIdBlock">
                        <p className="ResultsItemWorker__text--red">Номер заявки:</p>
                        <div className="ResultsItemWorker__applicationId">
                            <p className="ResultsItemWorker__text--red  ResultsItemWorker__text--applicationId">{applicationId}</p>
                            <div className="FullApplicationInfo__question--icon" onMouseEnter={hoverShowQuestionApplicationId} onMouseLeave={hoverHideQuestionApplicationId}>
                                <div style={showQuestionApplicationId ? {"display" : "block"} : {"display" : "none"}} className="FullApplicationInfo__comment--modal">
                                    <p className="FullApplicationInfo__comment--modal-text">Регистрационный номер заявки</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="FullApplicationInfo__workerIdBlock">
                        <div className="FullApplicationInfo__workerIdBlock--imageBlock">
                            <div className="FullApplicationInfo__image" style={{background: `#E34A4E  url(${image})center / cover no-repeat`}} />

                            <div className="FullApplicationInfo__workerIdAndQuestionBlock">
                                <p className="FullApplicationInfo__text">{specialist}</p>
                                <div className="FullApplicationInfo__specialistIdBlock">
                                    <p className="FullApplicationInfo__id">{specialistId}</p>
                                    <div className="FullApplicationInfo__question--icon" onMouseEnter={hoverShowQuestionSpecialist} onMouseLeave={hoverHideQuestionSpecialist}>
                                        <div style={showQuestionSpecialist ? {"display" : "block"} : {"display" : "none"}} className="FullApplicationInfo__comment--modal">
                                            <p className="FullApplicationInfo__comment--modal-text">У каждого специалиста есть уникальный IT-номер, во-первых это красиво, а во-вторых он совпадает с внутренним номером телефона. Вы всегда сможете позвонить напрямую исполнителю заявки или написать электронное письмо.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="FullApplicationInfo__workerIdBlock">
                        <p className="FullApplicationInfo__text">{workerName}</p>
                        <p className="FullApplicationInfo__id">{workerId}</p>
                    </div>


                    <div className="FullApplicationInfo__likeAndCommentBlock">

                        <div className="FullApplicationInfo__likeAndCommentBlock--icons">
                            <div className={`FullApplicationInfo__icon--widthLikeDislike FullApplicationInfo__icon--${classLikeDislike}`} />
                            <div className={`${isComment ? "FullApplicationInfo__comment" : null} FullApplicationInfo__comment--width`} onMouseEnter={isComment ? hoverShowQuestionComment: null} onMouseLeave={isComment ? hoverHideQuestionComment : null}>
                                <div style={showQuestionComment ? {"display" : "block"} : {"display" : "none"}} className="FullApplicationInfo__comment--modal">
                                    <p className="FullApplicationInfo__comment--modal-text">{props.commentMessage}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={fileImage ? "FullApplicationInfo__content" : "FullApplicationInfo__content--noFile"}>
                    <div className={fileImage ? "FullApplicationInfo__content--left" : "FullApplicationInfo__content--left FullApplicationInfo__content--left--noFile"}>
                        <h2 className="FullApplicationInfo__content__title">Детали заявки</h2>
                        <div className="FullApplicationInfo__content__head">
                            <div className="FullApplicationInfo__content__head--sides">
                                <p className="FullApplicationInfo__content__text--title">Ответственный отдел</p>
                                <p className="FullApplicationInfo__content__text">{department}</p>
                            </div>
                            <div className="FullApplicationInfo__content__head--sides">
                                <p className="FullApplicationInfo__content__text--title">Тема</p>
                                <p className="FullApplicationInfo__content__text">{subject}</p>
                            </div>
                        </div>
                        {isProblem ? <p className="FullApplicationInfo__content__text--title">Подробности</p> : null}
                        <div>
                            {allProblems}
                        </div>


                        <p className="FullApplicationInfo__content__text--title FullApplicationInfo__content__text--title--wide">{(status === "завершено" || status === "пауза" || status === "пауза" || status === "в работе" || status === "запланировано") ? "Результат" : status === "отменено" ? "Причины отмены заявки" : ""}</p>
                        <div >
                            {allSolution}
                        </div>
                        {!fileImage && status === "завершено" && currentSlide===0 ? <p onClick={nextSlide} className="FullApplicationInfo__backToWorkLink FullApplicationInfo__backToWorkLink--pushRight">Вернуть заявку в работу</p> : null}

                    </div>
                    <div className='FullApplication__swiper'>
                        <Swiper
                            style={{width: (!fileImage && currentSlide===0)? 0: 375,height: '100%', transition: 'width .3s ease'}}
                            // install Swiper modules
                            spaceBetween={0}
                            slidesPerView={1}
                            onSwiper={(swiperL) => {
                                setSwiper(swiperL);
                            }}
                            draggable={false}
                            allowTouchMove={false}
                            onSlideChange={() => console.log('slide change')}
                        >
                            <SwiperSlide >
                                {fileImage ? <div className="FullApplicationInfo__content--right">
                                    <h2 className="FullApplicationInfo__content--title">
                                        Прикрепленные файлы:
                                    </h2>
                                    {fileImage}

                                    {status === "завершено" ? <p onClick={nextSlide} className="FullApplicationInfo__backToWorkLink">Вернуть заявку в работу</p> : null}
                                </div> : <div ref={emptyRef}></div>}
                            </SwiperSlide>
                            <SwiperSlide style={{height: "auto"}}>
                                <div className='FullApplication__swiper_return'>
                                    <ApplicationBackModal
                                        needTrackbutton = {true} 
                                        hash={application._id} 
                                        applicationId={applicationId}/>
                                    <button className='FullApplication__swiper_close' onClick={prevSlide}>&lt;&lt; Назад</button>
                                </div>
                                
                            </SwiperSlide>
                        </Swiper>
                        
                        
                    </div>
                    
                    

                </div>


                <div className="FullApplicationInfo__footer" >
                    {!props.first ? <div className="FullApplicationInfo__btnLeft" onClick={props.goLeft}>
                                        <div className="FullApplicationInfo__arrowLeft" />
                                        <p className="FullApplicationInfo__btnTextLeft">
                                            Вернуться к предыдущей заявке
                                        </p>
                                    </div> : null}

                    {!props.last ? <div className="FullApplicationInfo__btnRight" onClick={props.goRight}>
                                        <p className="FullApplicationInfo__btnTextRight">
                                            Перейти к следующей заявке
                                        </p>
                                        <div className="FullApplicationInfo__arrowRight" />
                                    </div> : null}
                </div>
            </div>
            {isFileImageModal ? <div onClick={toggleModalImage} className="FullApplicationInfo__fileImage--modal">
                <div className="FullApplicationInfo__fileImage--modalCanvas">
                    <img className="FullApplicationInfo__fileImage" src={currentFileImage} alt={subject}/>
                </div>
            </div> : null}
        </>
    )
}

export default FullApplicationInfo;
